import { DEPLOYMENT_KIND_LABELS, type CalendarEventDto } from '@bhops/shared';

// 이벤트 일정의 칩 · 목록 표기(2026-11-02) — 통합 캘린더와 '다가오는 일정'이 같은 말을 쓴다.

/** '[이벤트 설치] 코엑스 B홀' · '[이벤트 회수] 코엑스 B홀'(오너 — 캘린더에 그 말머리로). */
export function eventChipTitle(e: CalendarEventDto, side: 'install' | 'return'): string {
  return `[이벤트 ${side === 'install' ? '설치' : '회수'}] ${e.location}`;
}

/**
 * '행사·전시 · GEN2 2대 · #912, #913' — 배정 전이면 '… 배정 전'. 단계가 있으면 앞에
 * '설치 완료 · ' · '회수 완료 · '.
 */
export function eventSubtitle(e: CalendarEventDto): string {
  const models = e.robotLines.map((l) => `${l.modelName} ${l.quantity}대`).join('/');
  const need = e.robotLines.reduce((n, l) => n + l.quantity, 0);
  const robots = e.robots.map((r) => r.label).join(', ');
  const parts = [
    DEPLOYMENT_KIND_LABELS[e.kind] ?? null,
    models || null,
    robots ? robots : need > 0 ? '배정 전' : null,
    e.robots.length > 0 && e.robots.length < need && !e.returned
      ? `${need - e.robots.length}대 더 배정 필요`
      : null,
  ].filter(Boolean);
  const stage = e.returned ? '회수 완료 · ' : e.installed ? '설치 완료 · ' : '';
  return `${stage}${parts.join(' · ')}`;
}
